import {CC_CONTRACT_DETAILS, CC_SURVEY_DETAILS} from '@cc-commons/cc-routing-roots';

export const CCDKO_DASHBOARD = 'dashboard';
export const CCDKO_CONTRACTS_LIST = 'contracts';
export const CCDKO_CONTRACT_DETAILS = CC_CONTRACT_DETAILS;
export const CCDKO_SURVEY_DETAILS = CC_SURVEY_DETAILS;
export const CCDKO_APPOINTMENTS_LIST = 'appointments';
export const CCDKO_APPOINTMENTS_DETAILS = 'details';
